
class Aggregator {

    days;
    activeGrants;
    shownGrants;
    planningMode;
    calendar;
    hasJobMoved;
    jobsMovedTo;
    suggestedJobs;

    constructor(days, activeGrants, shownGrants, planningMode, calendar, hasJobMoved, jobsMovedTo, suggestedJobs) {
        this.days = days;
        this.activeGrants = activeGrants;
        this.shownGrants = shownGrants;
        this.planningMode = planningMode;
        this.calendar = calendar;
        this.hasJobMoved = hasJobMoved;
        this.jobsMovedTo = jobsMovedTo;
        this.suggestedJobs = suggestedJobs;
    }

    aggregate = (limitToDate) => {
        return this.days.reduce((agg, day) => {
            if (limitToDate && day.date !== limitToDate) {
                return agg;
            }

            return {...agg, [day.date]: this.mapGrants(day.date)};
        }, {});
    };

    mapGrants = (date) => {
        const agg = [];

        this.activeGrants.forEach(grant => {
            if (!this.shownGrants[grant.id]) {
                return;
            }

            agg.push({
                assignTo: grant.userId,
                jobs: this.aggregateGrant(date, grant.userId)
            });
        });

        if (this.shownGrants['unassigned']) {
            agg.push({
                assignTo: null,
                jobs: this.aggregateGrant(date, null),
            });
        }

        return agg;
    }

    aggregateGrant = (date, userId) => {
        if (this.planningMode === 'suggested') {
            return this.aggregateSuggestedJobs(date, userId);
        } else if (this.planningMode === 'appointments') {
            return this.aggregateAppointments(date, userId);
        } else {
            console.error('Unknown planning mode', this.planningMode);
            return [];
        }
    }

    aggregateSuggestedJobs(date, userId)
    {
        const jobs = [];

        this.suggestedJobs[date].forEach(job => {
            if (this.hasJobMoved(job.id)) {
                return;
            }

            if (job.assignedTo === userId) {
                jobs.push({jobId: job.id, customerId: job.customerId});
            }
        });

        return [...jobs, ...this.getJobsMovedTo(date, userId)];
    }

    aggregateAppointments(date, userId)
    {
        const dateAppointments = this.calendar?.appointments?.appointments?.[date] ?? [];
        const appointments = dateAppointments.filter(app => app.type === 'Job')
                                            .filter(app => app.assignedTo === userId)
                                            .filter(app => this.hasJobMoved(app.jobId) === false);
        return [
            ...appointments.filter(app => !!app.job).map(app => ({jobId: app.jobId, customerId: app.job.customerId})),
            ...this.getJobsMovedTo(date, userId),
        ];
    }

    getJobsMovedTo(date, userId)
    {
        return this.jobsMovedTo(userId ?? 'null', date).map(move => ({jobId: move.jobId, customerId: move.customerId}));
    }

}

export default Aggregator;